module.exports = __webpack_public_path__ + "static/media/friendship.50c0a4ef.svg";